import { useState } from "react";

export const useGenerateWitness = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const generateWitness = async (clave, back) => {
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await fetch("http://192.30.241.102:5000/get_witness", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          clave,
          pw: "WITNESS_SCRAP",
          back,
        }),
      });

      if (!response.ok) {
        throw new Error("Error en la solicitud");
      }

      const data = await response.json();
      setMessage(data.message);
      return data;
    } catch (err) {
      setError(err.message);
      console.error("Hubo un error al generar el testigo:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { generateWitness, loading, error, message };
};
